import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getSettings = () => api.get("/settings").then((r) => r.data);
export const saveSettings = (data) => api.put("/settings", data).then((r) => r.data);
export const getTariffs = () => api.get("/tariffs").then((r) => r.data);
export const createTariff = (data) => api.post("/tariffs", data).then((r) => r.data);
export const updateTariff = (id, data) => api.put(`/tariffs/${id}`, data).then((r) => r.data);
export const deleteTariff = (id) => api.delete(`/tariffs/${id}`).then((r) => r.data);
export const getCards = () => api.get("/cards").then((r) => r.data);
export const saveCard = (token, data) => api.put(`/cards/${token}`, data).then((r) => r.data);
export const syncNow = () => api.post("/sync").then((r) => r.data);
export const getMonths = () => api.get("/months").then((r) => r.data);
export const getOverview = (month) => api.get("/overview", { params: { month } }).then((r) => r.data);
export const getSessions = (month, id_tag) =>
  api.get("/sessions", { params: { month, id_tag } }).then((r) => r.data);
export const deleteSessions = (ids) => api.post("/sessions/delete", { ids }).then((r) => r.data);
export const pdfUrl = (month, id_tag) =>
  `${API}/billing/pdf?month=${encodeURIComponent(month)}&id_tag=${encodeURIComponent(id_tag)}`;
export const cregPdfUrl = (month, id_tag) =>
  `${API}/billing/creg/pdf?month=${encodeURIComponent(month)}&id_tag=${encodeURIComponent(id_tag)}`;
export const getCregTariffs = () => api.get("/creg-tariffs").then((r) => r.data);
export const saveCregTariff = (data) => api.post("/creg-tariffs", data).then((r) => r.data);
export const deleteCregTariff = (q) => api.delete(`/creg-tariffs/${q}`).then((r) => r.data);
export const price4 = (v) => `€${Number(v || 0).toFixed(4)}`;
export const fmtDateNl = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};
export const CREG_REGIONS = { flanders: "Vlaanderen", brussels: "Brussel", wallonia: "Wallonië" };

export const eur = (v) =>
  new Intl.NumberFormat("nl-BE", { style: "currency", currency: "EUR" }).format(v || 0);
export const kwh = (v) =>
  new Intl.NumberFormat("nl-BE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v || 0);

export const MONTHS_NL = [
  "januari", "februari", "maart", "april", "mei", "juni",
  "juli", "augustus", "september", "oktober", "november", "december",
];
export const monthLabel = (m) => {
  if (!m) return "";
  const [y, mm] = m.split("-");
  return `${MONTHS_NL[parseInt(mm, 10) - 1]} ${y}`;
};
